import { Sparkles } from "lucide-react";

/**
 * Badge Article 50 AI Act - marque tout contenu produit par un modele d'IA.
 * Utilise sur :
 *  - reponses des 12 agents (AgentChatPage)
 *  - verdicts de Table Ronde (TableRondePage)
 *  - resumes / analyses
 *
 * Style Dossier Bancaire (gold + navy) - homogene avec le reste de l'app.
 */
export default function AiGeneratedBadge({ label = "Genere par IA", size = "sm", className = "" }) {
  const isXs = size === "xs";
  const style = isXs
    ? { padding: "2px 6px", fontSize: "9px", gap: "3px" }
    : { padding: "3px 8px", fontSize: "10px", gap: "4px" };
  return (
    <span
      data-testid="ai-generated-badge"
      title="Contenu produit par un modele d'IA (Article 50 AI Act)"
      className={`inline-flex items-center rounded-full font-semibold uppercase tracking-wider ${className}`}
      style={{
        background: "#FFF8E7",
        border: "1px solid #E9D9B0",
        color: "#7A5B2C",
        letterSpacing: "0.08em",
        ...style,
      }}
    >
      <Sparkles style={{ width: isXs ? "9px" : "10px", height: isXs ? "9px" : "10px" }} />
      {label}
    </span>
  );
}
